import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { prefetchArticleBySlug } from '../../lib/publicContentCache';
import type { ArticleRow } from '../../../../shared/schemas/article';

interface RecentIntegrationsSidebarProps {
  entries: ArticleRow[];
  currentSlug: string;
}

export function RecentIntegrationsSidebar({ entries, currentSlug }: RecentIntegrationsSidebarProps) {
  const others = entries.filter((entry) => entry.slug !== currentSlug);

  return (
    <aside className="flex w-article-sidebar flex-col gap-6">
      <p className="text-caption-lg text-text-tertiary">Integrations</p>

      {others.map((entry) => (
        <a
          key={entry.slug}
          href={`/articles/${entry.slug}`}
          className="text-btn leading-normal text-text-primary transition-colors hover:text-text-secondary"
          onMouseEnter={() => prefetchArticleBySlug(entry.slug)}
          onFocus={() => prefetchArticleBySlug(entry.slug)}
        >
          {entry.title}
        </a>
      ))}

      <a href="/integrations" className="site-btn-secondary site-btn-md">
        All integrations
        <ArrowUpRight size={14} />
      </a>
    </aside>
  );
}
